export default __webpack_public_path__ + "static/media/blog03.d9223238.png";